import { ca } from '@cian/analytics';

export const trackCtaClick = (source: 'consultation' | 'ticket') => {
  let label;

  if (source === 'consultation') {
    label = 'plate_consultation';
  }

  if (source === 'ticket') {
    label = 'plate_application';
  }

  ca('eventSite', {
    name: 'oldevent',
    category: 'DemandCpd',
    action: 'click',
    label,
  });
};
